export class Grade {
  id: string;
  name: string;
}
